import { render, staticRenderFns } from "./home-4.vue?vue&type=template&id=07cd973c&"
import script from "./home-4.vue?vue&type=script&lang=js&"
export * from "./home-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports